export default function(string) {
  return string
    .replace(/([a-z])([A-Z])/g, '$1-$2') // get all lowercase letters that are near to uppercase ones
    .replace(/[\s-]+/g, '_') // replace all spaces and middle dash
    .toLowerCase() // convert to lower case
}
